import { render } from "./brief-item.vue?vue&type=template&id=0ee2f79e&scoped=true&ts=true"
import script from "./brief-item.vue?vue&type=script&lang=ts"
export * from "./brief-item.vue?vue&type=script&lang=ts"

import "./brief-item.vue?vue&type=style&index=0&id=0ee2f79e&lang=scss&scoped=true"
/* custom blocks */
import block0 from "../i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Fcomponents%2Flead-form%2Fcomponents%2Fselect-brief%2Fcomponents%2Fbrief-item.vue&external"
if (typeof block0 === 'function') block0(script)
import block1 from "../../../i18n/messages.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Fcomponents%2Flead-form%2Fcomponents%2Fselect-brief%2Fcomponents%2Fbrief-item.vue&external"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee2f79e"]])

export default __exports__